import GoogleAds from '../../components/GoogleAds/GoogleAds';
import DHTML from '../wrappers/DHTML/DHTML';
import CertonaZone from '../wrappers/CertonaZone/CertonaZone';
import SeoMetaTag from '../../components/SeoMetaTags/SeoMetaTags';
import ImageBanner from '../wrappers/ImageBanner/ImageBanner';
import ImageMapBanner from '../wrappers/ImageMapBanner/ImageMapBanner';
import ShoppableImages from '../../components/ShoppableImages/ShoppableImages';
import VisualNav from '../wrappers/VisualNav/VisualNav';
import HotDeals from '../wrappers/HotDeals/HotDeals';
import Grid from '../wrappers/Grid/Grid';
import CategoryDeals from '../../components/CategoryDeals/CategoryDeals';
import EditorialContent from '../../components/EditorialContent/EditorialContent';
import StyledForYou from '../../components/StyledForYou/StyledForYou';
import PromotionalBanner from '../wrappers/PromotionalBanner/PromotionalBanner';
import FitFinder from '../wrappers/FitFinder/FitFinder';
import StickyTimer from '../wrappers/StickyTimer/StickyTimer';
import QAndA from '../wrappers/QAndA/QAndA';

export default {
    ads: {
        component: GoogleAds,
    },
    seoblock: {
        component: DHTML,
    },
    recommendations: {
        component: CertonaZone,
    },
    seotag: {
        component: SeoMetaTag,
    },
    imagebanner: {
        component: ImageBanner,
    },
    imagehotspots: {
        component: ImageMapBanner,
    },
    shoppableimages: {
        component: ShoppableImages,
    },
    dhtml: {
        component: DHTML,
    },
    dhtmlrte: {
        component: DHTML,
    },
    visualnav: {
        component: VisualNav,
    },
    hotdeals: {
        component: HotDeals,
    },
    gridcomponent: {
        component: Grid,
    },
    nucleus: {
        component: EditorialContent,
    },
    herovariant: {
        component: EditorialContent,
    },
    editorial: {
        component: EditorialContent,
    },
    story: {
        component: EditorialContent,
    },
    styledforyou: {
        component: StyledForYou,
    },
    hero: {
        component: EditorialContent,
    },
    interactivevisnav: {
        component: FitFinder,
    },
    textbanner: {
        component: PromotionalBanner,
    },
    categorypromo: {
        component: CategoryDeals,
    },
    categoryhotdeals: {
        component: CategoryDeals,
    },
    timer: {
        component: StickyTimer,
    },
    qanda: {
        component: QAndA,
    },
};
